import { blankDocumentBytes } from "@docx-editor.dev/core";
import { strFromU8, strToU8, unzipSync, zipSync } from "fflate";
import { DEFAULT_FAMILY } from "./substitutes";

// The engine's own empty document with one thing changed: the face its defaults name, which is Calibri there and
// Roboto here. Everything else in it — the styles, the spacing, the page — is the engine's, so what somebody starts
// writing in is what the engine would have handed them, set in the face this site is set in.
export function blankDocument(): Uint8Array {
  const files = unzipSync(blankDocumentBytes());
  const styles = files[STYLES];
  if (!styles) return blankDocumentBytes();
  files[STYLES] = strToU8(withDefaultFace(strFromU8(styles), DEFAULT_FAMILY));
  return zipSync(files);
}

// Only the fonts inside the document defaults, so a style that names a face of its own keeps it.
export function withDefaultFace(styles: string, family: string): string {
  return styles.replace(
    DEFAULTS,
    (block) =>
      block.replace(
        /<w:rFonts\b[^>]*\/>/,
        (fonts) => fonts.replace(/(w:(?:ascii|hAnsi|eastAsia|cs))="[^"]*"/g, `$1="${family}"`),
      ),
  );
}

const STYLES = "word/styles.xml";

const DEFAULTS = /<w:rPrDefault>[\s\S]*?<\/w:rPrDefault>/;
